import CustomSelect from '@op/components/FilterCommon/components/CustomSelect';
import useLanguage from '@op/hooks/useLanguage';
import React from 'react';
import { useTopicList } from '../../hook/useTopicAnalysisFlow';

export default function TopicSelect({
  defaultValue = [],
  onChange,
  topicFilter,
}: {
  defaultValue: string[];
  onChange: (value: string[]) => void;
  topicFilter: any;
}) {
  const { topicList, loading, value, setValue } = useTopicList({
    defaultValue,
    filter: topicFilter,
  });
  const { formatMessage } = useLanguage();

  return (
    <CustomSelect
      matchButtonWidth
      style={{ width: 250 }}
      placeholderText={formatMessage('Customized Topic')}
      onClear={() => setValue([])}
      selectOptionsInfo={[value, setValue]}
      options={topicList}
      hasAllSelected={topicList?.length > 1}
      onChange={(data: string[]) => {
        if (data.length === topicList.length) {
          onChange([]);
        } else {
          onChange(data);
        }
      }}
    ></CustomSelect>
  );
}
